/* eslint-disable no-param-reassign */
/* eslint-disable react/no-unescaped-entities */
import { ArrowLeftOutlined, CloudUploadOutlined, DeleteOutlined, EditOutlined, EyeOutlined, FilterOutlined, RightCircleTwoTone, DownCircleTwoTone } from '@ant-design/icons';
import {
    Button, Form,
    Input,
    Modal,
    Space,
    Table,
    Tabs,
    Tooltip,
    Typography,
    Upload, notification, DatePicker, Drawer, Select, Layout, Row, Col, Card,
    Radio
} from 'antd';
import { get } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import history from '../../services/history';

import { AddOrUpdateConfigData, getConfogListFromDatabse } from '../../redux/Pricing gudiance/saga';


const { Option } = Select;
const { Title, Text } = Typography;
const { TabPane } = Tabs;
//const { TabPane } = Tabs;
//const { Column } = Table;
//const { Search } = Input;

//const { Option } = Select;
const FeatureLicenseConfig = (props) => {

    const {
        setConfigData, setFormData, formData, ConfigData, showConfiguration, Contractor, setShowConfiguration
    } = props;

    const M500_application_features = ["Basic", "Solid Wire", "Horizontal Tracking", 'Fronius Power Supply', 'Lincoln Power Supply']; //TIG welding removed as discussed by vinay
    const P625_application_features = ["Basic", "360 degree Welding", "Zone to Zone Ramping", "Touch ramp", 'Fronius Power Supply'];
    const [SaveLoading, setSaveLoading] = useState(false);
    const [isInputfeildChanged, setIsInputfeildChanged] = useState(false)




    // useEffect(() => {


    //     {
    //         (async () => {


    //             const config = await getConfogListFromDatabse()
    //             console.log('confog', config)
    //             if (config && config[0] && config[0].Configuration) {
    //                 setConfigData(config[0])
    //                 setFormData(config[0].Configuration)
    //             }
    //             //setFormData(config.Configuration)
    //         })();
    //     }


    // }, [])


    /** get user Access */

    const OnSave = async () => {
        setSaveLoading(true);

        const data = {
            ID: 2,
            Configuration: formData
        }
       console.log(data)
        await AddOrUpdateConfigData(data)
        setIsInputfeildChanged(false)
        setSaveLoading(false);

    }



    const WeldingSystemUI = () => {


        const Tier_discount_display = {

            "0to10": '< 10 Month',
            "11to50": "11 to 50 Month",
            "51to100": "51 to 100 Month",
            "101to150": "101 to 150 Month",
            "151+": ' > 15 Month'
        }
        const getTitle = (title) => {
            if (title == 'Lincoln Power Supply')
                return 'Lincoln PS'
            else if (title == 'Fronius Power Supply')
                return 'Fronius TPSi'
            else if (title == 'Zone to Zone Ramping')
                return 'Zone Ramping'
            else if (title == 'Zone to Zone Ramping')
                return 'Zone Ramping'
            else if (title == 'Touch and Ramp')
                return 'Touch'
            else
                return title
        }

        // const [formData, setFormData] = useState({
        //     Tier_discount: {
        //         "0to10": 0,
        //         "11to50": 0.1,
        //         "51to100": 0.15,
        //         "101to150": 0.2,
        //         "151+": 0.25,
        //     },
        //     Duration_discount: {
        //         "1 Year": 0,
        //         "2 Year": 0.05,
        //         "3 Year": 0.1,
        //         "5 Year": 0.15,
        //         Perpetual: 0.2,
        //     },
        //     Recovery_details: {
        //         Payback: {
        //             Duration_months: 12,
        //             "Units_sold/rent": 100,
        //         },
        //         margin: 0.7,
        //     },

        //     "Welding_system": {
        //         "M-500": {
        //             "_comment": "Cost spent on building the licensing platform",
        //             "Dev_cost": 500000,
        //             "Basic": {

        //                 "Dev_weightage": 0.8,
        //                 "Purchase_probability": 100,

        //             },
        //             "Solid Wire": {

        //                 "Dev_weightage": 0.05,
        //                 "Purchase_probability": 0.5,

        //             },
        //             "Horizontal Tracking": {

        //                 "Dev_weightage": 0.05,
        //                 "Purchase_probability": 0.5,

        //             },
        //             "Fronius Power Supply": {

        //                 "Dev_weightage": 0.05,
        //                 "Purchase_probability": 0.5,

        //             },
        //             "Lincoln Power Supply": {

        //                 "Dev_weightage": 0.05,
        //                 "Purchase_probability": 0.5,

        //             }
        //         },
        //         "P-625": {
        //             "_comment": "Cost spent on building the licensing platform",
        //             "Dev_cost": 500000,
        //             "Basic": {

        //                 "Dev_weightage": 0.8,
        //                 "Purchase_probability": 100,

        //             },
        //             "360 degree Welding": {

        //                 "Dev_weightage": 0.05,
        //                 "Purchase_probability": 0.5,

        //             },
        //             "Zone to Zone Ramping": {

        //                 "Dev_weightage": 0.05,
        //                 "Purchase_probability": 0.5,

        //             },
        //             "Touch ramp": {

        //                 "Dev_weightage": 0.05,
        //                 "Purchase_probability": 0.5,

        //             },
        //             "Fronius Power Supply": {

        //                 "Dev_weightage": 0.05,
        //                 "Purchase_probability": 0.5,

        //             }
        //         }
        //     }
        // });

        const handleInputChange = (category, key, value) => {
            //console.log(key, value,formData)

            setIsInputfeildChanged(true)
            setFormData((prev) => ({
                ...prev,
                [category]: {
                    ...prev[category],
                    [key]: value,
                },
            }));
        };

        const handleNestedInputChange = (category, subCategory, key, value) => {
            setIsInputfeildChanged(true)
            setFormData((prev) => ({
                ...prev,
                [category]: {
                    ...prev[category],
                    [subCategory]: {
                        ...prev[category][subCategory],
                        [key]: value,
                    },
                },
            }));
        };
        const handleWeldingInputChange = (system, feature, key, value) => {
            setIsInputfeildChanged(true);
            setFormData((prev) => ({
                ...prev,
                Welding_system: {
                    ...prev.Welding_system,
                    [system]: {
                        ...prev.Welding_system[system],
                        [feature]: {
                            ...prev.Welding_system[system][feature],
                            [key]: value,
                        },
                    },
                },
            }));
        };

        const handleWeldingDevCostChange = (category, value) => {
            setIsInputfeildChanged(true);
            setFormData((prev) => ({
                ...prev,
                Welding_system: {
                    ...prev.Welding_system,
                    [category]: {
                        ...prev.Welding_system[category],
                        Dev_cost: value, // Updating the Dev_cost value
                    },
                },
            }));
        };
        return (
            <div className="custom-tab h-100" style={{ paddingTop: '10px' }}>

                <Row gutter={24}>
                    <Col span={8}>
                        <Card className="Cashflow-custom-card"
                            //style={{ overflowY: "auto", overflowX: "hidden", height: '100%' }}
                            headStyle={{ alignItems: 'left', display: 'flow', justifyContent: 'space-between', width: '100%', paddingTop: '10px' }}
                            title={
                                <div className='' style={{ position: 'relative', display: 'flex', width: '100%' }}>


                                    <span style={{ marginLeft: '0px' }}>{"Tier Discount"}</span>

                                </div>
                            }
                        >
                            {Object.keys(Tier_discount_display).map((key) => (
                                <Row gutter={12} style={{ paddingTop: '5px' }}>
                                    <Col span={12} style={{ textAlign: 'left', }} >
                                        <span>{Tier_discount_display[key]}</span> {/* Label */}
                                    </Col>
                                    <Col span={12}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Input
                                                addonAfter="%"
                                                className="Data360-addafter"
                                                type="number"
                                                min={0}
                                                step={0.1}
                                                value={Number((formData.Tier_discount[key] * 100).toFixed(4))}
                                                style={{ borderRadius: '5px', width: '100%' }} // Ensures full width within Col
                                                onChange={(e) => {
                                                    let inputValue = e.target.value;

                                                    // Prevent NaN by ensuring an empty input resets to 0

                                                    const newValue = Number(inputValue) / 100;
                                                    handleInputChange("Tier_discount", key, parseFloat(newValue.toFixed(4)));
                                                }
                                                }
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            ))}

                        </Card>
                    </Col>

                    <Col span={8}>
                        <Card className="Cashflow-custom-card"
                            // style={{ overflowY: "auto", overflowX: "hidden", height: '100%' }}
                            headStyle={{ alignItems: 'left', display: 'flow', justifyContent: 'space-between', width: '100%', paddingTop: '10px' }}
                            title={
                                <div className='' style={{ position: 'relative', display: 'flex', width: '100%' }}>


                                    <span style={{ marginLeft: '0px' }}>{"Duration Discount"}</span>

                                </div>
                            }
                        >

                            {Object.keys(formData.Duration_discount).map((key) => (
                                <Row gutter={12} style={{ paddingTop: '5px' }}>
                                    <Col span={12} style={{ textAlign: 'left', }} >
                                        <span>{key}</span> {/* Label */}
                                    </Col>
                                    <Col span={12}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Input addonAfter='%' className='Data360-addafter'
                                                type="number"
                                                min={0}
                                                step={0.1}
                                                value={Number((formData.Duration_discount[key] ).toFixed(4))}
                                                style={{ borderRadius: '0px' }}

                                                onChange={(e) => {
                                                    const newValue = Number(e.target.value);
                                                    handleInputChange("Duration_discount", key, parseFloat(newValue.toFixed(4)))
                                                }}
                                            />

                                        </div>
                                    </Col>
                                </Row>
                            ))}


                        </Card>
                    </Col>

                    <Col span={8}>
                        <Card className="Cashflow-custom-card"
                            style={{ overflowY: "auto", overflowX: "hidden", height: '100%' }}
                            headStyle={{ alignItems: 'left', display: 'flow', justifyContent: 'space-between', width: '100%', paddingTop: '10px' }}
                            title={
                                <div className='' style={{ position: 'relative', display: 'flex', width: '100%' }}>


                                    <span style={{ marginLeft: '0px' }}>{"Recovery Details"}</span>

                                </div>
                            }
                        >

                            <Row gutter={12} style={{ paddingTop: '5px' }}>
                                <Col span={12} style={{ textAlign: 'left', }} >
                                    <span>{'Payback Duration'}</span> {/* Label */}
                                </Col>

                                <Col span={12}>



                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Input addonAfter='month' className='Data360-addafter'
                                            type="number"
                                            min={0}
                                            step={0.1}
                                            value={formData.Recovery_details.Payback.Duration_months}
                                            style={{ borderRadius: '0px' }}


                                            onChange={(e) =>
                                                handleNestedInputChange("Recovery_details", "Payback", "Duration_months", Number(e.target.value))
                                            }
                                        />

                                    </div>
                                </Col>
                            </Row>
                            <Row gutter={12} style={{ paddingTop: '5px' }}>
                                <Col span={12} style={{ textAlign: 'left', }} >
                                    <span>{'Units Sold'}</span> {/* Label */}
                                </Col>

                                <Col span={12}>

                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Input 
                                            type="number"
                                            min={0}
                                            max={100}
                                            step={0.1}
                                            //value={Number(formData.Recovery_details.Payback["Units_sold/rent"] * 100).toFixed(4)}
                                            style={{ borderRadius: '15px' }}
                                            value={Number(formData.Recovery_details.Payback["Units_sold/rent"])}

                                            onChange={(e) => {
                                                const newValue = Number(e.target.value);
                                                handleNestedInputChange("Recovery_details", "Payback", "Units_sold/rent", newValue)
                                            }}
                                        />

                                    </div>
                                </Col>
                            </Row>


                            <Row gutter={12} style={{ paddingTop: '5px' }}>
                                <Col span={12} style={{ textAlign: 'left', }} >
                                    <span>{'Profit Margin'}</span> {/* Label */}
                                </Col>

                                <Col span={12}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Input addonAfter='%' className='Data360-addafter'
                                            type="number"
                                            min={0}
                                            max={100}
                                            step={0.1}
                                            value={Number((formData.Recovery_details.margin * 100).toFixed(4))}
                                            style={{ borderRadius: '0px' }}

                                            onChange={(e) => {
                                                const newValue = Number(e.target.value) / 100;
                                                handleInputChange("Recovery_details", 'margin', parseFloat(newValue.toFixed(4)))
                                            }}
                                        />

                                    </div>
                                </Col>
                            </Row>

                        </Card>
                    </Col>

                </Row >
                <Row gutter={24} style={{ paddingTop: '10px' }}>
                    {["M-500", "P-625"].map((category) => (
                        <Col span={12} key={category}>

                            <Card className="Cashflow-custom-card"
                                style={{ overflowY: "auto", overflowX: "hidden", height: '100%' }}
                                // style={{ height: "calc(100vh - 650px)", fontSize: '20px' }}
                                // style={{ overflowY: "auto", overflowX: "hidden" }}
                                headStyle={{ alignItems: 'left', display: 'flow', justifyContent: 'space-between', width: '100%', paddingTop: '10px' }}
                                title={
                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                                        {/* Left Content */}
                                        <span>{category}</span>

                                        {/* Right Content */}
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingRight: '5px' }}>
                                            <span style={{ fontSize: '16px' }}>{'Development Spent'}</span> {/* Label */}
                                            <Input
                                                addonBefore={<div style={{ width: '100%', textAlign: 'center' }}>$</div>}
                                                className='Data360-addbefore'
                                                min={0}
                                                type='number'
                                                style={{ width: '150px', textAlign: 'right' }}  // Adjust width & align text
                                                value={formData.Welding_system[category].Dev_cost} // Get the Dev_cost value dynamically
                                                onChange={(e) => handleWeldingDevCostChange(category, Number(e.target.value))}
                                            />
                                        </div>
                                    </div>
                                }
                            >



                                <Row gutter={12} style={{ paddingTop: '5px' }}>
                                    <Col span={8} style={{ textAlign: 'left', color: '#ef314c' }} >

                                        {'License'}

                                    </Col>
                                    <Col span={8} style={{ textAlign: 'Center', color: '#ef314c' }} >

                                        {'Development Weightage'}

                                    </Col>
                                    <Col span={8} style={{ textAlign: 'Center', color: '#ef314c' }} >

                                        {'Purchase Probability'}

                                    </Col>
                                </Row>



                                {(category === "M-500" ? M500_application_features : P625_application_features).map(
                                    (feature) => (

                                        <Row gutter={12} style={{ paddingTop: '5px' }}>
                                            <Col span={8} style={{ textAlign: 'left', }} >

                                                {getTitle(feature)}

                                            </Col>


                                            <>
                                                <Col span={8} >
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <Input addonAfter='%' className='Data360-addafter'
                                                            type="number"
                                                            min={0}

                                                            step={0.1}
                                                            value={Number((formData.Welding_system[category][feature]['Dev_weightage'] * 100).toFixed(4))}
                                                            style={{ borderRadius: '0px' }}

                                                            onChange={(e) => {
                                                                const newValue = Number(e.target.value) / 100;
                                                                handleWeldingInputChange(category, feature, 'Dev_weightage', parseFloat(newValue.toFixed(4)))
                                                            }}
                                                        />

                                                    </div>
                                                </Col>
                                                <Col span={8} >
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <Input addonAfter='%' className='Data360-addafter'
                                                            type="number"
                                                            min={0}

                                                            step={0.1}
                                                            value={Number((formData.Welding_system[category][feature]['Purchase_probability'] * 100).toFixed(4))}
                                                            style={{ borderRadius: '0px' }}

                                                            onChange={(e) => {
                                                                const newValue = Number(e.target.value) / 100;
                                                                handleWeldingInputChange(category, feature, 'Purchase_probability', parseFloat(newValue.toFixed(4)))
                                                            }}
                                                        />

                                                    </div>
                                                </Col>
                                            </>

                                        </Row>

                                    )
                                )}
                            </Card>
                        </Col>
                    ))}
                </Row>
                <Form.Item>
                    {/* <Button type="primary" key="apply" shape="round" style={{ marginTop: '5px'  }}
                                                            onClick={() => setShowConfiguration(false)}
                                                        >
                                                            Save
                                                        </Button> */}
                    <Button
                        key="apply"
                        type="primary"
                        onClick={() => OnSave()}
                        disabled={!isInputfeildChanged}
                        loading={SaveLoading}
                        style={{
                            borderRadius: '30px',
                            position: "fixed",
                            bottom: "20px",
                            right: "30px",
                            zIndex: 1000,
                        }}
                    >
                        Save
                    </Button>

                </Form.Item>
            </div >
        );
    };



    return (

        <div className="d-flex flex-column h-100">
            <div className="custom-line" />
            {WeldingSystemUI()}
        </div>
    );
};
const mapStateToProps = ({ }) => {


    return {

    }
}

const mapDispatchToProps = {


}


export default connect(mapStateToProps, mapDispatchToProps)(FeatureLicenseConfig);

